
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.828 11.824v5.685l3.747-2.842-3.747-2.843z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M5.86 29.333h28.28c.648 0 1.172-.596 1.172-1.333V1.333C35.313.596 34.788 0 34.142 0H5.859c-.647 0-1.171.596-1.171 1.333V28c0 .737.524 1.333 1.171 1.333zm10.624-20c0-.492.238-.944.62-1.175.38-.234.844-.205 1.202.066l7.032 5.333c.326.248.521.664.521 1.11 0 .445-.195.861-.521 1.109l-7.032 5.333a1.052 1.052 0 01-1.203.067c-.38-.232-.619-.684-.619-1.176V9.333zM38.828 34.667H11.503C11.017 33.118 9.729 32 8.203 32c-1.526 0-2.814 1.118-3.3 2.667H1.172C.524 34.667 0 35.263 0 36s.524 1.333 1.172 1.333h3.731C5.39 38.882 6.677 40 8.203 40c1.526 0 2.815-1.118 3.3-2.667h27.325c.648 0 1.172-.596 1.172-1.333s-.524-1.333-1.172-1.333z","fill":"#E2E8F0"}})])
          )
        }
      }
    